/* eslint-disable */
import React, { useCallback, useEffect, useMemo } from 'react';
import { MIS_HEALTH_CHECK } from '../../../../Constants/strings';
import '../HealthCheck.scss';
import { TableUtility } from '@utility/dynamic-table';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useAuth } from '../../../../Hooks/useAuth';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../../../Api/resources/serviceURLs';
import { serviceName } from '../../../../Api/resources/serviceConstants';
import normalizeTableUtilityResponse from '../../../../Utils/tableUtilityResponse';

import { MIS_ARCHITECT_HEALTH_CHECK } from '../../../../Api/resources/endPoint';
import { getExportFileName, getExportFileNameWithDate } from '../../../Delivery/utils';

const fetchBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  if (process.env.NODE_ENV === 'production') {
    return (
      process.env.REACT_APP_API_URL + serviceURL + '/api' + MIS_ARCHITECT_HEALTH_CHECK
    );
  } else {
    return (
      process.env.REACT_APP_API_URL +
      `:${servicePort}` +
      serviceURL +
      '/api' +
      MIS_ARCHITECT_HEALTH_CHECK
    );
  }
};

const baseURL = fetchBaseURL();

const ArchHealthCheck = () => {
  const { userProfile } = useAuth();

  const measureHeaderTextLengths = () => {
    setTimeout(() => {
      const thElements = document.querySelectorAll('th.p-resizable-column');

      if (thElements.length > 0) {
        thElements.forEach((th, index) => {
          const headerSpan = th.querySelector('span.typography.header');

          if (headerSpan) {
            const headerText = headerSpan.textContent || '';
            if (headerText.length > 32 && headerText.length <= 50) {
              headerSpan.classList.add('wrap-long-text');
              const headerColumnDiv = th.querySelector('.header-column');
              if (headerColumnDiv) {
                const svg = headerColumnDiv.querySelector('svg');
                if (svg) {
                  svg.classList.add('margin-adjusted');
                }

                const threeDotButton =
                  headerColumnDiv.querySelector('.three-dot');
                if (threeDotButton) {
                  threeDotButton.classList.add('margin-adjusted');
                }
              }
            } else if(headerText.length > 50) {
              headerSpan.classList.add('wrap-longest-text');
              const headerColumnDiv = th.querySelector('.header-column');
              if (headerColumnDiv) {
                const svg = headerColumnDiv.querySelector('svg');
                if (svg) {
                  svg.classList.add('margin-adjusted');
                }

                const threeDotButton =
                  headerColumnDiv.querySelector('.three-dot');
                if (threeDotButton) {
                  threeDotButton.classList.add('margin-adjusted');
                }
              }
            } else {
              headerSpan.classList.remove('wrap-long-text');
              const headerColumnDiv = th.querySelector('.header-column');
              if (headerColumnDiv) {
                const svg = headerColumnDiv.querySelector('svg');
                if (svg) {
                  svg.classList.remove('margin-adjusted');
                }

                const threeDotButton =
                  headerColumnDiv.querySelector('.three-dot');
                if (threeDotButton) {
                  threeDotButton.classList.remove('margin-adjusted');
                }
              }
            }
          }
        });
      } 
    }, 100);
  };
  useEffect(() => {
    measureHeaderTextLengths();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.tagName === 'TH' || node.querySelectorAll) {
              measureHeaderTextLengths();
              break;
            }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  const handleApiResponse = useCallback((response) => {
    return normalizeTableUtilityResponse(response);
  }, []);
  const configuration = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      baseURL,
      userInfo: {
        emailId: userProfile.email,
        permissions: userProfile.permissions,
        roleDetails: userProfile.roleDetails,
        employeeId: userProfile.employeeId,
      },
      apiEndpoints: {
        getAllViews: { endpoint: 'views', enabled: false },
        getFilteredData: { endpoint: '', enabled: true },
        saveOrUpdateView: { endpoint: 'view', enabled: false },
        deleteView: { endpoint: 'view-delete', enabled: false },
        download: {
          endpoint: 'export',
          enabled: true,
          filename: () => getExportFileName('Architecture Health Check'),
          sheetName: () => getExportFileNameWithDate('Architecture Health Check'),
        },
      },
      handler: {
        handleFilteredApiResponse: handleApiResponse,
      },
      headers: {
        token: userProfile.access_token, // Any additional custom headers
      },
      showToolBar: true,
      showPagination: true,
      toolBarSettings: {
        // show or hide tool bar elements
        showToolBarHeading: true,
        toolBarHeading: 'Architecture Health Check Details',
        showAddNew: false,
        showDownloadExcel: true,
        showColumnCustomize: false,
        showHelp: true,
        showSearch: false,
        showSaveView: false,
        showExpandCollapse: false,
        showReset: true,
        additionalElements: [],
      },
    },
    tableSettings: {
      size: 'small',
      loaderSkeleton: {
        rows: 10,
        bodyCells: 2,
        columns: 5,
      },
      paginationConfig: {
        page: 1,
        limit: 10,
        rowsPerPageOptions: [10, 20, 30, 40],
      },
      showExpandCollapse: true,
      tableScrollHeight: '52vh',
      maxFrozenColumns: {
        desktop: 4,
        tablet: 2,
        mobile: 1,
      },
    },
  }), [handleApiResponse, userProfile.access_token, userProfile.email, userProfile.employeeId, userProfile.permissions, userProfile.roleDetails]);

  return (
    <div className="health-check-outer-layer">
      <div className="health-check">
        <h1 className="health-check-title">{MIS_HEALTH_CHECK.ARCHITECTURE_TITLE}</h1>
        <div className="table-utility">
          <TableUtility configuration={configuration} />
        </div>
      </div>
    </div>
  );
  
};

export default ArchHealthCheck;
